import gql from 'graphql-tag';
import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';

const MUTATION = gql`
  mutation ExtractBlogInstructionsFromText($sectionId: ID!, $text: String!) {
    extractBlogInstructionsFromText(sectionId: $sectionId, text: $text) {
      instructions
      status
      extractionErrors
    }
  }
`;

const prepareContext = (params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"ExtractBlogInstructionsFromText" request [${JSON.stringify(params)}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const extractBlogInstructionsBasedOnText = (sectionId, text) => {
  const variables = { sectionId, text };

  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables,
      context: prepareContext(variables),
    })
    .then(({ data }) => getSingleProp(data));
};
